module.exports = __webpack_public_path__ + "img/DSC_1786.0fd09e60.JPG";